import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";

const NotFound = () => {
  const { setSearchOpen } = useStore();
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
      <p className="overline text-gold mb-4">404</p>
      <h1 className="font-serif text-6xl md:text-8xl leading-none mb-5">She's not here.</h1>
      <p className="text-espresso/60 mb-10 max-w-md">The page you're looking for may have moved.</p>
      <div className="flex flex-wrap justify-center gap-3 text-[0.72rem] tracking-[0.18em] uppercase">
        <button onClick={() => setSearchOpen(true)} className="border border-espresso px-6 py-3 hover:bg-espresso hover:text-cream transition-colors">Search</button>
        <Link to="/collections/new-in" className="border border-espresso px-6 py-3 hover:bg-espresso hover:text-cream transition-colors">Discover New In</Link>
        <Link to="/" className="border border-espresso px-6 py-3 hover:bg-espresso hover:text-cream transition-colors">Return Home</Link>
      </div>
    </div>
  );
};

export default NotFound;
